import { createReducer } from 'redux-create-reducer'
import type { TrackId } from 'types/track'
import { SET_COPY_METADATA } from '@disco/constants/ActionTypes'
export type CopyMetadataState = {
  sourceTrackId?: TrackId | null
  targetTrackIds?: TrackId[]
  returnPath?: string
}
const initialState: CopyMetadataState = {
  sourceTrackId: null,
  targetTrackIds: [],
}
export const copyMetadataReducer = createReducer<CopyMetadataState, any>(
  initialState,
  {
    [SET_COPY_METADATA](state, { sourceTrackId, targetTrackIds, returnPath }) {
      return {
        ...state,
        sourceTrackId:
          sourceTrackId === undefined ? state.sourceTrackId : sourceTrackId,
        targetTrackIds: targetTrackIds ?? state.targetTrackIds,
        returnPath: returnPath ?? state.returnPath,
      }
    },
  },
)
